import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  Divider,
  FormControlLabel,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { formatNumber, formatValor } from "../../helpers/formaters";
import FormasPagamentoTable from "../tables/FormasPagamentoTable";
import errorHandler from "../core/store/errorHandler";
import axios from "axios";
import { headers } from "../core/store/localStorage";
import ErrorModal from "./ErrorModal";

const headerColor = "#669966";
const currentUser = sessionStorage.getItem("userName");
const currentEmp = sessionStorage.getItem("empName");
const API_URL = sessionStorage.getItem("apiUrl");
const PAGE_SIZE = 30;

function Section({ title, children }) {
  return (
    <Paper variant="outlined" sx={{ borderRadius: 1, overflow: "hidden" }}>
      <Box
        sx={{
          px: 1.5,
          py: 0.6,
          width: "100%",
          bgcolor: "#669966",
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>
          {title}
        </Typography>
      </Box>
      <Box sx={{ p: 1.5 }}>{children}</Box>
    </Paper>
  );
}

export default function LiquidacaoModal({
  open,
  onClose,
  onConfirm,
  dados = {},
  tipoFormaPagamentoList = [],
  tipoFormaPagamentoListAtivos = [],
  bancosList = [],
  agenciasList = [],
  contasList = [],
  setIsLiquidado = () => {},
  setIsEstornado = () => {},
  setSituacao = () => {},
  setAtraso = () => {},
  setData = () => {},
  setValorPagamento = () => {},
  setFormas = () => {},
  setValorCorrigido = () => {},
  setSituacaoId = () => {},
}) {
  const textFieldStyles = {
    marginTop: "0.5rem",
    "& .MuiInputBase-root": {
      height: "30px",
      fontSize: 13,
      backgroundColor: "inherit",
      display: "flex",
      alignItems: "center",
    },
    "& .MuiInputBase-input": {
      height: "30px",
      boxSizing: "border-box",
      cursor: "text",
      fontSize: "10px",
      textAlign: "left",
      "&::placeholder": {
        fontSize: "10px",
        opacity: 1,
        textAlign: "left",
      },
    },
    "& .MuiInputLabel-root": {
      fontSize: 10,
      transform: "translate(10px, 6px) scale(1)",
    },
    "& .MuiInputLabel-shrink": {
      transform: "translate(10px, -8px) scale(0.75)",
    },
  };

  const [dataPagto, setDataPagto] = useState("");
  const [competencia, setCompetencia] = useState("");
  const [valorPagto, setValorPagto] = useState("");
  const [atualizaContaCorrente, setAtualizaContaCorrente] = useState(true);
  const [openPayloadModal, setOpenPayloadModal] = useState(false);
  const [payloadErrors, setPayloadErrors] = useState([]);
  const [formasPagamento, setFormasPagamento] = useState([]);

  useEffect(() => {
    if (!open) return;
    setDataPagto(dados.dataPagto ?? "");
    setCompetencia(dados.competencia ?? "");

    const v = dados.valorCorrigido || dados.valor || "";
    setValorPagto(v);
    // console.log(dados.id);

    setFormasPagamento([
      {
        id: "init",
        tipo: "",
        descricao: "",
        dataConciliacao: "",
        valor: v,
        banco: "",
        agencia: "",
        conta: "",
        numCheque: "",
      },
    ]);
  }, [open]);

  const totalResumo = useMemo(() => {
    return dados.valorCorrigido || dados.valor || valorPagto || "";
  }, [dados, valorPagto]);

  const handleConfirm = async () => {
    const errors = [];

    if (!Array.isArray(formasPagamento) || formasPagamento.length === 0) {
      errors.push("Informe ao menos uma forma de pagamento.");
    } else {
      formasPagamento.forEach((p, index) => {
        if (!String(p?.tipo ?? "").trim())
          errors.push(`Tipo de pagamento é obrigatório.`);
        if (!String(p?.dataConciliacao ?? "").trim())
          errors.push(`Data de Conciliação é obrigatória.`);
        if (!String(p?.valor ?? "").trim()) errors.push(`Valor é obrigatório.`);
        if (!String(p?.banco ?? "").trim()) errors.push(`Banco é obrigatório.`);
        if (!String(p?.agencia ?? "").trim())
          errors.push(`Agência é obrigatória.`);
        if (!String(p?.conta ?? "").trim()) errors.push(`Conta é obrigatória.`);
      });
    }

    if (errors.length) {
      setPayloadErrors(errors);
      setOpenPayloadModal(true);
      return;
    }

    const payload = {
      id: dados.id,
      numTitulo: dados.numTitulo,
      liquidado: true,
      situacao: "Pago",
      situacaoId: "1",
      data: dados.dataPagto,
      valorPagamento: valorPagto.replace("R$", "").trim(),
      formasPagamento: formasPagamento.map((p) => ({
        tipo: String(p.tipo ?? ""),
        descricao: p.descricao ?? "",
        dataConciliacao: p.dataConciliacao ?? "",
        valor: String(p.valor ?? "")
          .replace("R$", "")
          .trim(),
        bancoId: String(p.banco ?? ""),
        agenciaId: String(p.agencia ?? ""),
        contaId: String(p.conta ?? ""),
        numCheque: p.nroCheque ?? p.numCheque ?? "",
      })),
    };

    const nextFormasPagamentoState = formasPagamento.map((p) => ({
      id: p.id,
      tipo: String(p.tipo ?? ""),
      descricao: p.descricao ?? "",
      dataConciliacao: p.dataConciliacao ?? "",
      valor: String(p.valor ?? ""),
      banco: String(p.banco ?? ""),
      agencia: String(p.agencia ?? ""),
      conta: String(p.conta ?? ""),
      nroCheque: p.nroCheque ?? p.numCheque ?? "",
      tipoTitulo: p.tipoTitulo ?? "",
    }));

    console.log(payload);

    try {
      await axios.post(
        `${API_URL}/contasapagar/liquidacao`,
        payload,
        headers(),
      );

      setFormas(nextFormasPagamentoState);
      setData(dados.dataPagto);
      setValorPagamento(valorPagto);
      setAtraso("");
      setIsLiquidado(true);
      setIsEstornado(false);
      setSituacao("Pago");
      setSituacaoId("1");

      onConfirm?.(payload);
      onClose();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      PaperProps={{ sx: { borderRadius: 2, overflow: "hidden" } }}
    >
      <Box
        sx={{
          px: 2,
          py: 1,
          bgcolor: headerColor,
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Box>
          <Typography sx={{ fontWeight: 800, fontSize: 16 }}>
            Liquidação
          </Typography>
          <Typography sx={{ fontSize: 12, opacity: 0.9 }}>
            Confira os dados e informe o pagamento antes de confirmar.
          </Typography>
        </Box>
      </Box>

      <DialogContent sx={{ p: 2 }}>
        <Grid container spacing={1.5}>
          <Grid item xs={12} md={9}>
            <Grid container spacing={1.5}>
              <Grid item xs={12}>
                <Section title="Documento">
                  <Grid container spacing={1} alignItems="flex-end">
                    <Grid item size={{ xs: 12, md: 6, xl: 5 }}>
                      <TextField
                        sx={textFieldStyles}
                        fullWidth
                        size="small"
                        color="success"
                        label="Fornecedor"
                        value={dados.fornecedorNome || ""}
                        InputProps={{
                          readOnly: true,
                          style: {
                            fontFamily: "Poppins",
                            fontSize: 11,
                            color: "#000000ff",
                            backgroundColor: "#d2d2d2ff",
                          },
                        }}
                      />
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 4, md: 2, lg: 2.5, xl: 3 }}>
                      <TextField
                        sx={textFieldStyles}
                        fullWidth
                        size="small"
                        color="success"
                        label="Nº Título"
                        value={dados.numTitulo || ""}
                        InputProps={{
                          readOnly: true,
                          style: {
                            fontFamily: "Poppins",
                            fontSize: 11,
                            color: "#000000ff",
                            backgroundColor: "#d2d2d2ff",
                          },
                        }}
                      />
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 4, md: 1, xl: 1 }}>
                      <TextField
                        sx={textFieldStyles}
                        fullWidth
                        color="success"
                        size="small"
                        label="Parc."
                        value={dados.parcela || ""}
                        InputProps={{
                          readOnly: true,
                          style: {
                            fontFamily: "Poppins",
                            fontSize: 11,
                            color: "#000000ff",
                            backgroundColor: "#d2d2d2ff",
                          },
                        }}
                      />
                    </Grid>

                    <Grid
                      item
                      size={{ xs: 12, sm: 4, md: 1.5, lg: 1.25, xl: 3 }}
                    >
                      <TextField
                        sx={textFieldStyles}
                        fullWidth
                        color="success"
                        size="small"
                        label="Nº Documento"
                        value={dados.numDocumento || ""}
                        InputProps={{
                          readOnly: true,
                          style: {
                            fontFamily: "Poppins",
                            fontSize: 11,
                            color: "#000000ff",
                            backgroundColor: "#d2d2d2ff",
                          },
                        }}
                      />
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 6, md: 1.5, lg: 1.25 }}>
                      <TextField
                        sx={textFieldStyles}
                        fullWidth
                        color="success"
                        size="small"
                        type="date"
                        label="Data Emissão"
                        value={dados.dataEmissao || ""}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          readOnly: true,
                          style: {
                            fontFamily: "Poppins",
                            fontSize: 11,
                            color: "#000000ff",
                            backgroundColor: "#d2d2d2ff",
                          },
                        }}
                      />
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 6, md: 1.5, lg: 1.25 }}>
                      <TextField
                        sx={textFieldStyles}
                        fullWidth
                        color="success"
                        size="small"
                        type="date"
                        label="Data Vencto."
                        value={dados.dataVencto || ""}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          readOnly: true,
                          style: {
                            fontFamily: "Poppins",
                            fontSize: 11,
                            color: "#000000ff",
                            backgroundColor: "#d2d2d2ff",
                          },
                        }}
                      />
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 6, md: 1.5, lg: 1.25 }}>
                      <TextField
                        sx={textFieldStyles}
                        fullWidth
                        color="success"
                        size="small"
                        type="date"
                        label="Data Previsão"
                        value={dados.dataPrevisao || ""}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          readOnly: true,
                          style: {
                            fontFamily: "Poppins",
                            fontSize: 11,
                            color: "#000000ff",
                            backgroundColor: "#d2d2d2ff",
                          },
                        }}
                      />
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 6, md: 1.75, lg: 1.25 }}>
                      <TextField
                        sx={textFieldStyles}
                        fullWidth
                        color="success"
                        size="small"
                        label="Atraso (dias)"
                        value={dados.atrasoDias || ""}
                        InputProps={{
                          readOnly: true,
                          style: {
                            fontFamily: "Poppins",
                            fontSize: 11,
                            color: "#000000ff",
                            backgroundColor: "#d2d2d2ff",
                          },
                        }}
                      />
                    </Grid>

                    <Grid item size={{ xs: 12, md: 7.25, lg: 8.25, xl: 7 }}>
                      <TextField
                        sx={textFieldStyles}
                        fullWidth
                        color="success"
                        size="small"
                        label="Breve Descrição"
                        value={dados.breveDescricao || ""}
                        InputProps={{
                          readOnly: true,
                          style: {
                            fontFamily: "Poppins",
                            fontSize: 11,
                            color: "#000000ff",
                            backgroundColor: "#d2d2d2ff",
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Section>
              </Grid>

              <Grid item size={{ xs: 12 }}>
                <Box
                  sx={{
                    width: "100%",
                    display: "grid",
                    overflow: "auto",
                  }}
                >
                  <FormasPagamentoTable
                    value={formasPagamento}
                    onChange={setFormasPagamento}
                    textFieldStyles={textFieldStyles}
                    tipoFormaPagamentoList={tipoFormaPagamentoList}
                    tipoFormaPagamentoListAtivos={tipoFormaPagamentoListAtivos}
                    bancosList={bancosList}
                    formatNumber={formatNumber}
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid item size={{ xs: 12 }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              <Section title="Valores">
                <Grid container spacing={1}>
                  <Grid item size={{ xs: 12, sm: 2.4 }}>
                    <TextField
                      sx={textFieldStyles}
                      fullWidth
                      size="small"
                      label="Valor"
                      color="success"
                      value={dados.valor || ""}
                      InputProps={{
                        readOnly: true,
                        style: {
                          fontFamily: "Poppins",
                          fontSize: 11,
                          color: "#000000ff",
                          backgroundColor: "#d2d2d2ff",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 2.4 }}>
                    <TextField
                      sx={textFieldStyles}
                      fullWidth
                      size="small"
                      label="Vr. juros/dia"
                      color="success"
                      value={dados.jurosDia || ""}
                      InputProps={{
                        readOnly: true,
                        style: {
                          fontFamily: "Poppins",
                          fontSize: 11,
                          color: "#000000ff",
                          backgroundColor: "#d2d2d2ff",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 2.4 }}>
                    <TextField
                      sx={textFieldStyles}
                      fullWidth
                      size="small"
                      color="success"
                      label="Multa (%)"
                      value={dados.multaPerc || ""}
                      InputProps={{
                        readOnly: true,
                        style: {
                          fontFamily: "Poppins",
                          fontSize: 11,
                          color: "#000000ff",
                          backgroundColor: "#d2d2d2ff",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 2.4 }}>
                    <TextField
                      sx={textFieldStyles}
                      fullWidth
                      size="small"
                      color="success"
                      label="Acerto"
                      value={dados.acerto || ""}
                      InputProps={{
                        readOnly: true,
                        style: {
                          fontFamily: "Poppins",
                          fontSize: 11,
                          color: "#000000ff",
                          backgroundColor: "#d2d2d2ff",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 2.4 }}>
                    <TextField
                      sx={textFieldStyles}
                      fullWidth
                      size="small"
                      color="success"
                      label="Vr. Corrigido"
                      value={dados.valorCorrigido || ""}
                      InputProps={{
                        readOnly: true,
                        style: {
                          fontFamily: "Poppins",
                          fontSize: 11,
                          color: "#000000ff",
                          backgroundColor: "#d2d2d2ff",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Section>

              <Section title="Pagamento">
                <Grid container spacing={1} alignItems="flex-end">
                  <Grid item size={{ xs: 12, sm: 2.25, md: 1.75, xl: 1.25 }}>
                    <TextField
                      sx={textFieldStyles}
                      fullWidth
                      size="small"
                      color="success"
                      type="date"
                      label="Data"
                      value={dataPagto}
                      onChange={(e) => setDataPagto(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item size={{ xs: 12, sm: 2.4, md: 1.75, xl: 1.5 }}>
                    <TextField
                      sx={textFieldStyles}
                      fullWidth
                      size="small"
                      color="success"
                      label="Valor"
                      InputProps={{
                        readOnly: true,
                      }}
                      sx={{
                        ...textFieldStyles,
                        "& .MuiInputBase-root": {
                          bgcolor: "rgba(0, 0, 0, 0.14)",
                          cursor: "default",
                        },
                        "& .MuiInputLabel-root": {
                          color: "text.secondary",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "divider",
                        },
                        "& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                          {
                            borderColor: "divider",
                          },
                        "& input": {
                          fontSize: "13px",
                          caretColor: "transparent",
                        },
                      }}
                      value={valorPagto}
                      onChange={(e) => setValorPagto(e.target.value)}
                      onBlur={(e) =>
                        setValorPagto(formatNumber(e.target.value, true))
                      }
                    />
                  </Grid>

                  <Grid item size={{ xs: 12, sm: 7.35, md: 8.5, xl: 2 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="success"
                          checked={atualizaContaCorrente}
                          onChange={(e) =>
                            setAtualizaContaCorrente(e.target.checked)
                          }
                        />
                      }
                      label="Atualiza Conta Corrente"
                      sx={{ "& .MuiFormControlLabel-label": { fontSize: 12 } }}
                    />
                  </Grid>

                  <Grid item size={{ xs: 12, xl: 12 }}>
                    <Box
                      sx={{
                        mt: 0.5,
                        p: 1,
                        borderRadius: 1,
                        bgcolor: "#f6f7f6",
                        border: "1px solid",
                        borderColor: "divider",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Typography sx={{ fontSize: 12, fontWeight: 800 }}>
                        Total
                      </Typography>
                      <Typography sx={{ fontSize: 12, fontWeight: 800 }}>
                        {totalResumo || "-"}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Section>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>

      <Box
        sx={{
          display: { xs: "flex", md: "flex" },
          justifyContent: "flex-end",
          alignItems: "center",
          px: 2,
          py: 1.25,
          borderTop: "1px solid",
          borderColor: "divider",
          bgcolor: "#fafafa",
        }}
      >
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button variant="outlined" color="inherit" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirm}
            sx={{ bgcolor: headerColor, "&:hover": { bgcolor: "#5a8d5a" } }}
          >
            Confirmar Liquidação
          </Button>
        </Box>
      </Box>

      <ErrorModal
        open={openPayloadModal}
        onClose={() => setOpenPayloadModal(false)}
        errors={payloadErrors}
      />
    </Dialog>
  );
}
